import React  from "react";
import Header from "./head/Header";
import Footer from "./Footer";
import Navbar from "./head/Navbar";

const MainTable = (props) => {

  return (
    <div className="dnw-sheet-body">
      <Header />
      <Navbar />
      {props.children}

      <div className="modules_bottom">
        <div className="clear"/>
      </div>

      <Footer />
    </div>
  );
};

export default MainTable;
